var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "File Lockup / * Elements / FIle Format / JPG - Large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File-Lockup-/-*-Elements-/-FIle-Format-/-JPG---Large",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-5",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#DE5862",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 1.71428571
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2857143,0 C23.2324881,-1.73919536e-16 24,0.767511857 24,1.71428571 L23.9998869,17.678 L16.6608955,10.2986245 L16.511652,10.1732421 C16.0917726,9.8807394 15.5119744,9.92302905 15.138378,10.2998228 L15.138378,10.2998228 L9.10892324,16.3791627 L5.88784654,13.131003 L5.73707512,13.0041733 C5.31271881,12.7087601 4.72569141,12.7556275 4.35333399,13.1420574 L4.35333399,13.1420574 L-0.000113072273,17.66 L-1.59872522e-14,1.71428571 C-1.61031941e-14,0.767511857 0.767511857,-2.70169674e-16 1.71428571,0 L22.2857143,0 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    stroke: "#DE5862",
    strokeWidth: 1.71428571,
    x: 0.857142857,
    y: 0.857142857,
    width: 22.2857143,
    height: 22.2857143,
    rx: 1.71428571
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DE5862",
    x: 6.85714286,
    y: 5.71428571,
    width: 4.57142857,
    height: 4.57142857,
    rx: 2.28571429
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.002b1822cba68440584906cb3920d25b.svg";
export { ForwardRef as ReactComponent };